// blakfy-cookie/src/i18n/translations/en.js — English translations

export default {
  title: "Cookie Preferences",
  intro: "This site uses cookies to enhance your experience. See our Cookie Policy for details.",
  policyLink: "Cookie Policy",
  acceptAll: "Accept All",
  rejectAll: "Reject All",
  preferences: "Preferences",
  save: "Save Choices",
  close: "Close",
  cat: {
    essential: {
      title: "Essential Cookies",
      desc: "Required for the site to function. Cannot be disabled.",
      always: "Always active",
    },
    analytics: { title: "Analytics Cookies", desc: "Used to collect anonymous visit statistics." },
    marketing: {
      title: "Marketing Cookies",
      desc: "Used for personalized advertising and retargeting.",
    },
    functional: {
      title: "Functional Cookies",
      desc: "Used to remember preferences like language, theme, region.",
    },
  },
  placeholder: {
    title: "Content blocked",
    desc: "You need to allow {category} cookies to view this content.",
    cta: "Allow",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
